export default "__VITE_ASSET__CHstO_W5__"